export default __webpack_public_path__ + "static/media/standinbgTableBgDec3.692b70d6.png";